import React from "react";
import { formatFileSize } from "../utils";
import { FileUploadConfig } from "../types";
import { ATTACHMENT_FIELD_STYLES } from "./styles";

interface FileUploadInfoDisplayProps {
  config: FileUploadConfig;
}

const FileUploadInfoDisplay: React.FC<FileUploadInfoDisplayProps> = ({
  config
}) => {
  return (
    <div style={ATTACHMENT_FIELD_STYLES.fileInfo}>
      • 개별 파일 최대 크기: {formatFileSize(config.maxFileSize)}
      <br />• 전체 파일 최대 크기: {formatFileSize(config.maxTotalSize)}
    </div>
  );
};

export default FileUploadInfoDisplay;
